import "@rainbow-me/rainbowkit/styles.css";
import {
  ConnectButton,
  connectorsForWallets,
  RainbowKitProvider,
} from "@rainbow-me/rainbowkit";
import {
  configureChains,
  createConfig,
  useDisconnect,
  useSwitchNetwork,
  WagmiConfig,
} from "wagmi";

import { publicProvider } from "wagmi/providers/public";
import React, { useEffect, useState } from "react";
import { helperConstants as constants } from "../helpers/helperConstants";

import {
  walletConnectWallet,
  metaMaskWallet,
  trustWallet,
  rabbyWallet,
  rainbowWallet,
  coinbaseWallet,
  ledgerWallet,
} from "@rainbow-me/rainbowkit/wallets";

const supportedChains = constants.helpers.supportedChains;

const { chains, publicClient, webSocketPublicClient } = configureChains(
  supportedChains,
  [publicProvider()]
);

const projectId = "680a79ea8d1873053b92b970da717428";

export const Web3WalletProvider = ({ children }) => {
  const [isSafePal, setSafePal] = useState(false);
  const [count, setCount] = useState(0);

  const [wagmiClient, setWagmiClient] = useState(null);

  useEffect(() => {
    if (count < 5 && !isSafePal) {
      setTimeout(() => {
        if ((typeof window !== "undefined" && window.ethereum) || count == 4) {
          const connectors = connectorsForWallets([
            {
              groupName: "Recommended",

              wallets: [
                metaMaskWallet({ chains, projectId }),
                trustWallet({ chains, projectId }),
                coinbaseWallet({ appName: "Bit5 Lending", chains }),
                rainbowWallet({ chains, projectId }),
                walletConnectWallet({ chains, projectId }),
                rabbyWallet({ chains }),
                ledgerWallet({ chains, projectId }),
              ],
            },
          ]);

          setWagmiClient(
            createConfig({
              connectors,
              autoConnect: true,
              publicClient,
              webSocketPublicClient,
            })
          );

          setSafePal(true);
        }
        setCount(count + 1);
      }, 50);
    }
  }, [count]);

  if (!isSafePal || !wagmiClient) {
    return null;
  }

  return (
    <WagmiConfig config={wagmiClient}>
      <RainbowKitProvider chains={chains}>{children}</RainbowKitProvider>
    </WagmiConfig>
  );
};

export const ConnectButtonWrapper = ({ children }) => {
  return (
    <ConnectButton.Custom>
      {({ openConnectModal }) => (
        <div onClick={openConnectModal}>{children}</div>
      )}
    </ConnectButton.Custom>
  );
};

export const DisconnectButtonWrapper = ({ children }) => {
  const dc = useDisconnect();
  const { disconnect } = dc;
  return <div onClick={disconnect as any}>{children}</div>;
};

export const useSwitchNetworkWrapper = () => {
  const { chains, switchNetwork } = useSwitchNetwork();

  if (!switchNetwork) {
    return {
      chains,
      switchNetwork: () => {
        alert(
          "Please Manually Switch Your Network to And Connect Your Wallet Again!"
        );
      },
    };
  }

  return { chains, switchNetwork };
};
